import TableVariable from '@/components/tasklist/TableVariable';

export default function DetailTask({ show, taskDetail = {} }: { show: boolean; taskDetail?: any }) {
  return (
    <div className={`${show ? 'block' : 'hidden'}`}>
      <TableVariable variables={taskDetail?.variables} />
    </div>
  );
}
